<template>
  <div></div>
</template>

<script>
export default {
  name: "null"
};
</script>

<style></style>
